module.exports = __webpack_public_path__ + "img/syncing.66f8dbe9.svg";